import { render, staticRenderFns } from "./Resend-OTP-Popup.html?vue&type=template&id=1ca92468&scoped=true&external"
import script from "./Resend-OTP-Popup.js?vue&type=script&lang=js&external"
export * from "./Resend-OTP-Popup.js?vue&type=script&lang=js&external"
import style0 from "./Resend-OTP-Popup.scss?vue&type=style&index=0&id=1ca92468&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca92468",
  null
  
)

export default component.exports